import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Attendance } from '../../../models';
import * as moment from 'moment';

@Component({
  selector: 'aqua-attendance-status-present',
  templateUrl: './attendance-status-present.component.html',
  styleUrls: ['./attendance-status-present.component.css']
})
export class AttendanceStatusPresentComponent implements OnInit, OnChanges {


  @Input()
  attendance: Attendance

  isPast = false;
  status = 'absent';
  statusPresent = 'present'
  info: string;
  secondHalfStatus = 'A'
  firstHalfStatus = 'A'

  shiftStatus = 'working';
  count = 0


  constructor() { }

  setData() {

    this.isPast = moment(this.attendance.ofDate).isBefore(new Date(), 'day');
    if (this.attendance) {
      this.status = this.attendance.status
      this.firstHalfStatus = this.attendance.firstHalfStatus
      this.secondHalfStatus = this.attendance.secondHalfStatus
      this.count = this.attendance.count
      if (this.attendance.shift) {
        this.shiftStatus = this.attendance.shift.status
      }
    }
  }



  ngOnInit() {
    this.setData()
  }

  ngOnChanges() {
    this.setData();
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/components/attendance-status-present/attendance-status-present.component.ts